// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FooterBreadcrumbs-module-listContainer-\\+2pej{display:flex;align-items:center}.FooterBreadcrumbs-module-breadcrumbs-DE3db{display:none}@media(min-width: 768px){.FooterBreadcrumbs-module-breadcrumbs-DE3db{display:flex}}.FooterBreadcrumbs-module-logo-ZFVMp{display:flex;margin-inline-end:var(--des-dimension-gap-and-padding-general-near-large);width:56px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listContainer": "FooterBreadcrumbs-module-listContainer-+2pej",
	"breadcrumbs": "FooterBreadcrumbs-module-breadcrumbs-DE3db",
	"logo": "FooterBreadcrumbs-module-logo-ZFVMp"
};
export default ___CSS_LOADER_EXPORT___;
